import React from 'react';
import { Accordion, Grid, KeyValue, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import { ParentDetails, SingleParentDetails } from '../../../../api/candidate/exam/model';
import { useStyles } from './style';

enum ParentRole {
  FATHER = 'FATHER',
  MOTHER = 'MOTHER',
}

const ParentParticulars = ({ parentDetail }: { parentDetail: ParentDetails }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const renderSingleDetails = (role: ParentRole, details: SingleParentDetails) => (
    <>
      <Grid container direction="row">
        <Grid xs={12}>
          <Typography variant="h4" className={classes.subheader}>
            {role === ParentRole.FATHER
              ? t('exam->>NonNationalExam.FatherDetails')
              : t('exam->>NonNationalExam.MotherDetails')}
          </Typography>
        </Grid>

        <Grid md={6} sm={12} xs={12}>
          <KeyValue
            capitalize={false}
            keyText={t('exam->>NonNationalExam.Name')}
            valueText={details.name || '-'}
          />
        </Grid>
        <Grid md={6} sm={12} xs={12}>
          <KeyValue
            keyText={t('exam->>NonNationalExam.Citizenship')}
            valueText={details.citizenship || '-'}
          />
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid md={6} sm={12} xs={12}>
          <KeyValue
            keyText={t('exam->>NonNationalExam.DocumentType')}
            valueText={details.documentType || '-'}
          />
        </Grid>
        <Grid md={6} sm={12} xs={12}>
          <KeyValue
            keyText={t('exam->>NonNationalExam.DocumentNumber')}
            valueText={details.documentNumber || '-'}
          />
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid md={6} sm={12} xs={12}>
          <KeyValue
            keyText={t('exam->>ParentParticulars.WorkPassType')}
            valueText={details.workPassType || '-'}
          />
        </Grid>
        <Grid md={6} sm={12} xs={12}>
          <KeyValue
            keyText={t('exam->>ParentParticulars.FIN')}
            valueText={details.finNumber || '-'}
          />
        </Grid>
      </Grid>
    </>
  );

  return (
    <Accordion defaultExpanded header={t('exam->>NonNationalExam.ParentParticulars')}>
      {parentDetail.fatherDetail &&
        renderSingleDetails(ParentRole.FATHER, parentDetail.fatherDetail)}
      {parentDetail.motherDetail &&
        renderSingleDetails(ParentRole.MOTHER, parentDetail.motherDetail)}
    </Accordion>
  );
};

export default ParentParticulars;
